import { render } from "./DealReportPage.vue?vue&type=template&id=064e9714"
import script from "./DealReportPage.vue?vue&type=script&lang=js"
export * from "./DealReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__